import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FindUser from './FindUser';
import Link from '@material-ui/core/Link';
import React from 'react';
import ReactDOM from 'react-dom';
import SignIn from './SignIn';
import User from './User';

import * as serviceWorker from './serviceWorker';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { MapEventEditor } from './WildSky/MapEventEditor';
import { EditorGroup as WildSkyEditorGroup } from './WildSky/EditorGroup';
import { PingTest } from './WildSky/PingTest';
import { AwsMonitor } from './WildSky/AwsMonitor';
import { ServerRelease } from './WildSky/ServerRelease';
import { RpcLogs } from './WildSky/RpcLogs';
import { TournamentEditor } from './WildSky/TournamentEditor';
import { Dashboard } from './WildSky/Dashboard';
import { Guild } from './WildSky/Guild';
import { Comments } from './WildSky/Comments';
import { WildSkyAggregate, SupportAggregate } from './Aggregate';
import { Update, UpdateSupport } from './Update';
import { MongoStats } from './WildSky/MongoStats';
import { FunctionRevisions } from './WildSky/FunctionRevisions';
import { FunctionRevisionDiff } from './WildSky/FunctionRevisionDiff';

import './index.css';
import { LazySelect } from './ReactProtos/CellSelect';
import { NaturalLanguageApi } from './WildSky/NaturalLanguageApi';
import { LeaderBoard as WildCastleLeaderBoard } from './WildCastle/LeaderBoard';
import { AsyncPvpLeaderBoard, AsyncPvpUser } from './WildCastle/AsyncPvpLeaderBoard';
import { TestServerScript } from './Components/TestServerScript';
import { McpTokens } from './McpTokens';

function NoSuchPage() {
    return <h1>No Such Page.</h1>;
}

class CheckLogin extends React.PureComponent {
    state = {
        loading: true,
        user: null,
        region: null,
        authorization: null,
        showDialog: false,
        version: null,
    };

    regions = ['us-west-1', 'ap-southeast-1', 'eu-central-1', 'dev', 'dev-regional'];

    componentDidMount() {
        fetch('/api/me')
            .then(response => response.json())
            .then(result => {
                if (result.user) {
                    console.log(result);
                    this.setState({
                        loading: false,
                        user: result.user,
                        region: result.region,
                        authorization: result.authorization,
                    });
                } else {
                    this.setState({ loading: false });
                }
            });
        fetch('/version')
            .then(response => response.json())
            .then(result => {
                this.setState({ version: result.result });
            });
    }

    onLogout = () => {
        this.setState({ logout: true });
        fetch('/api/logout')
            .then(response => response.json())
            .then(() => {
                this.setState({ logout: false, user: null });
            });
    }

    onCloseDialog = () => {
        this.setState({ showDialog: false });
    }

    onShowDialog = () => {
        this.setState({ showDialog: true });
    }

    onChangeRegion = pair => {
        const urls = {
            ['us-west-1']: 'https://support.wildsky.dev',
            ['ap-southeast-1']: 'https://supportap.wildsky.dev',
            ['eu-central-1']: 'https://supportec.wildsky.dev',
            ['dev']: 'https://devsupport.wildsky.dev',
            ['dev-regional']: 'https://devsupport.wildsky.dev:8080',
            // ['dev-http']: 'http://dev-support-470639081.us-west-1.elb.amazonaws.com',
            // ['dev-regional-http']: 'http://dev-support-470639081.us-west-1.elb.amazonaws.com:8081',
        };
        if (pair.value !== this.state.region && urls[pair.value]) {
            const target = urls[pair.value] + window.location.pathname + window.location.search;
            window.location.href = target;
        }
    }

    render() {
        if (this.state.loading) {
            return (<h1>Loading</h1>);
        }
        if (!this.state.user) {
            return (<Redirect to={`/login?url=${encodeURIComponent(window.location.pathname)}`} />);
        }
        return (<React.Fragment>
            <div>
                Admin: <Link onClick={this.onShowDialog}>{this.state.user}</Link>
                <a style={{ marginLeft: '8px' }} href="/" target="_blank" rel="noopener noreferrer">Home</a>
                <a style={{ marginLeft: '8px' }} href="/editor" target="_blank" rel="noopener noreferrer">Editor</a>
                <a style={{ marginLeft: '8px' }} href="/aws" target="_blank" rel="noopener noreferrer">Server</a>
                <a style={{ marginLeft: '8px' }} href="/dashboard" target="_blank" rel="noopener noreferrer">Dashboard</a>
                <a style={{ marginLeft: '8px' }} href="/guild" target="_blank" rel="noopener noreferrer">Guild</a>
                <a style={{ marginLeft: '8px' }} href="/comments" target="_blank" rel="noopener noreferrer">Comments</a>
                <a style={{ marginLeft: '8px' }} href="/tournament" target="_blank" rel="noopener noreferrer">Tournament</a>
                <a style={{ marginLeft: '8px' }} href="/aggregate" target="_blank" rel="noopener noreferrer">Aggregate</a>
                <a style={{ marginLeft: '8px' }} href="/update" target="_blank" rel="noopener noreferrer">Update</a>
                <a style={{ marginLeft: '8px' }} href="/release" target="_blank" rel="noopener noreferrer">Release</a>
                <a style={{ marginLeft: '8px' }} href="/lua" target="_blank" rel="noopener noreferrer">Lua</a>
                <a style={{ marginLeft: '8px' }} href="/nlp" target="_blank" rel="noopener noreferrer">NaturalLanguageApi</a>
                <a style={{ marginLeft: '8px' }} href="/castle_leader_board" target="_blank" rel="noopener noreferrer">WildCastleLeaderBoard</a>
                <a style={{ marginLeft: '8px' }} href="/async_pvp_leader_board" target="_blank" rel="noopener noreferrer">AsyncPvpLeaderBoard</a>
                <a style={{ marginLeft: '8px' }} href="/mcp-tokens" target="_blank" rel="noopener noreferrer">MCP</a>
                {
                    this.state.version &&
                    <a style={{ marginLeft: '8px' }} href={`https://gitlab.corp.dreamcraft.com/dreamcraft/wildsky-support/commits/${this.state.version}`} target="_blank" rel="noopener noreferrer">
                        @{this.state.version.substring(0, 7)}
                    </a>
                }
                <div style={{ display: 'inline-block', width: '200px', float: 'right' }}>
                    <LazySelect
                        value={{ value: this.state.region, label: this.state.region }}
                        options={this.regions.map(r => ({ value: r, label: r }))}
                        onChange={this.onChangeRegion}
                    />
                </div>
            </div>
            <Dialog open={this.state.showDialog} onClose={this.onCloseDialog}>
                <DialogTitle>{this.state.user}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {this.state.authorization && JSON.stringify(this.state.authorization, null, 4)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={this.onLogout}>Logout</Button>
                </DialogActions>
            </Dialog>
            <Switch>
                <Route path="/" exact component={FindUser} />
                <Route path="/find" component={FindUser} />
                <Route path="/user/:userId" component={User} />
                <Route path="/event" component={MapEventEditor} />
                <Route path="/editor" component={WildSkyEditorGroup} />
                <Route path="/ping" component={PingTest} />
                <Route path="/aws" component={AwsMonitor} />
                <Route path="/release" component={ServerRelease} />
                <Route path="/lua" exact component={FunctionRevisions} />
                <Route path="/lua/diff" component={FunctionRevisionDiff} />
                <Route path="/logs" component={RpcLogs} />
                <Route path="/tournament" component={TournamentEditor} />
                <Route path="/dashboard" component={Dashboard} />
                <Route path="/guild" component={Guild} />
                <Route path="/comments" component={Comments} />
                <Route path="/aggregate" component={WildSkyAggregate} />
                <Route path="/aggregate_support" component={SupportAggregate} />
                <Route path="/update" component={Update} />
                <Route path="/update_support" component={UpdateSupport} />
                <Route path="/mongo" component={MongoStats} />
                <Route path="/nlp" component={NaturalLanguageApi} />
                <Route path="/castle_leader_board" component={WildCastleLeaderBoard} />
                <Route path="/script" component={TestServerScript} />
                <Route path="/async_pvp_leader_board" component={AsyncPvpLeaderBoard} />
                <Route path="/async_pvp_user" component={AsyncPvpUser} />
                <Route path="/mcp-tokens" component={McpTokens} />
                <Route component={NoSuchPage} />
            </Switch>
        </React.Fragment>);
    }
}

ReactDOM.render(
    <Router>
        <Switch>
            <Route path="/login" component={SignIn} />
            <Route component={CheckLogin} />
        </Switch>
    </Router>,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
